import { GLSL_ARG } from "../typeMapping";
export default [
    {
        name: "mask",
        type: "combine",
        inputs: {},
        glsl: `
			vec4 c0 = ${GLSL_ARG.color0};
			vec4 c1 = ${GLSL_ARG.color1};
			
			float a = luminance(c1.rgb);
			return vec4(c0.rgb*a, a*c0.a);
		`,
        require: ["luminance"],
        lang: "<",
    },
    {
        name: "add",
        type: "combine",
        inputs: {
            amount: 1,
        },
        glsl: `
			vec4 c0 = ${GLSL_ARG.color0};
			vec4 c1 = ${GLSL_ARG.color1};

			return (c0 + c1) * amount + c0 * (1.0 - amount);
		`,
        lang: ".+",
    },
    {
        name: "sub",
        type: "combine",
        inputs: {
            amount: 1,
        },
        glsl: `
			vec4 c0 = ${GLSL_ARG.color0};
			vec4 c1 = ${GLSL_ARG.color1};

			return (c0 - c1) * amount + c0 * (1.0 - amount);
		`,
        lang: ".-",
    },
    {
        name: "layer",
        type: "combine",
        inputs: [],
        glsl: `
			vec4 c0 = ${GLSL_ARG.color0};
			vec4 c1 = ${GLSL_ARG.color1};
		
			return vec4(mix(c0.rgb, c1.rgb, c1.a), clamp(c0.a + c1.a, 0.0, 1.0));
		`,
        lang: "..",
    },
    {
        name: "blend",
        type: "combine",
        inputs: { amount: 0.5 },
        glsl: `
			return ${GLSL_ARG.color0} * (1.0 - amount) + ${GLSL_ARG.color1} * amount;
		`,
        lang: "§",
    },
    {
        name: "mult",
        type: "combine",
        inputs: {
            amount: 1,
        },
        glsl: `
			vec4 c0 = ${GLSL_ARG.color0};
			vec4 c1 = ${GLSL_ARG.color1};

			return c0 * (1.0 - amount) + (c0 * c1) * amount;
		`,
        lang: ".*",
    },
    {
        name: "diff",
        type: "combine",
        inputs: [],
        glsl: `
			vec4 c0 = ${GLSL_ARG.color0};
			vec4 c1 = ${GLSL_ARG.color1};

			return vec4(abs(c0.rgb-c1.rgb), max(c0.a, c1.a));
		`,
        lang: "./",
    },
];
